export default __webpack_public_path__ + "static/Gatsby-68bce794f3a7994ee0e684120bebcc9d.svg";